import { mockData } from './mockData';

// Helper to create mock responses
const createMockResponse = (data: any, status: number = 200) => {
  return new Response(JSON.stringify(data), {
    status,
    headers: { 'Content-Type': 'application/json' }
  });
};

export const mockApi = {
  auth: {
    login: async (username: string, password: string) => {
      await new Promise(resolve => setTimeout(resolve, 500));
      
      if (username === 'admin' && password === 'password') {
        return createMockResponse({
          message: 'Login successful',
          api_token: mockData.auth.login.api_key
        });
      }
      return createMockResponse(
        { message: 'Invalid credentials' },
        401
      );
    },

    create: async (username: string, password: string, role: string) => {
      await new Promise(resolve => setTimeout(resolve, 500));
      return createMockResponse({
        message: 'Admin user created successfully',
        api_token: 'new-mock-token-12345'
      });
    }
  },

  users: {
    getAll: async (page: number = 1, limit: number = 10) => {
      await new Promise(resolve => setTimeout(resolve, 500));
      return createMockResponse(mockData.users);
    },

    getById: async (userId: string) => {
      await new Promise(resolve => setTimeout(resolve, 500));
      return createMockResponse({
        user: mockData.userDetail.user,
        loans: mockData.userDetail.loans,
        documents: mockData.userDetail.documents
      });
    },
  },

  dashboard: {
    getStats: async () => {
      await new Promise(resolve => setTimeout(resolve, 500));
      return createMockResponse({
        statistics: mockData.dashboard.statistics,
        demographics: mockData.dashboard.demographics,
        recentLoans: mockData.dashboard.recentLoans,
        recentDocuments: mockData.dashboard.recentDocuments
      });
    },
  },

  documents: {
    download: async (documentId: number) => {
      await new Promise(resolve => setTimeout(resolve, 500));
      
      const mockBlob = new Blob(['Mock document content'], { type: 'application/octet-stream' });
      const mockResponse = new Response(mockBlob);
      mockResponse.headers.set('Content-Disposition', 'attachment; filename="document.pdf"');
      
      return mockResponse;
    },
  },
}; 